import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import "./FaqCsOne.css";

export const FaqCsOne = ({ content,heading }) => {
  return (
    <div className="keyzi_faqcsone--wrapper">
      <Container>
        <div className="keyzi_faqcsone--inner keyzi_newFaqcsOne--wrapper">
          <h2 className="sub_head">{heading}</h2>
          <Row className="justify-content-between">
            <Col lg={6} className="faqcsone--left">
              <Accordion defaultActiveKey="0">
                {content?.slice(0, Math.ceil(content.length / 2))?.map((item, index) => (
                  <Accordion.Item eventKey={String(index)} key={index}>
                    <Accordion.Header>{item?.title}</Accordion.Header>
                    <Accordion.Body>{item?.description}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>

            <Col lg={6} className="faqcsone--right">
              <Accordion>
                {content?.slice(Math.ceil(content.length / 2))?.map((item, index) => (
                  <Accordion.Item eventKey={String(index + Math.ceil(content.length / 2))} key={index + Math.ceil(content.length / 2)}>
                    <Accordion.Header>{item.title}</Accordion.Header>
                    <Accordion.Body>{item.description}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};
